"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.executeRules = exports.executeImmediateRules = void 0;
exports.executeRulesSuccess = executeRulesSuccess;
exports.getInActiveSelections = getInActiveSelections;
exports.getSelections = getSelections;
var _transform = _interopRequireDefault(require("lodash/transform"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _rulesApi = _interopRequireDefault(require("../api/rulesApi"));
var _filterSelections = _interopRequireDefault(require("../utils/filterSelections"));
var _filterInActiveSelections = _interopRequireDefault(require("../utils/filterInActiveSelections"));
var _settings = require("../settings");
var _choiceActions = require("./choiceActions");
var _ajaxStatusActions = require("./ajaxStatusActions");
var _actionTypes = require("./actionTypes");
function executeRulesSuccess(data, saveAttempts) {
  return function (dispatch, getState) {
    var state = getState().configurator;
    return dispatch({
      type: _actionTypes.EXECUTE_RULES_SUCCESS,
      data: data,
      saveAttempts: saveAttempts,
      // eslint-disable-next-line no-param-reassign
      disabledChoices: (0, _transform["default"])(data.disabledChoices, function (obj, it) {
        return obj[it] = state.choices[it];
      }, {}),
      selectedChoices: data.selectedChoices,
      choices: state.choices,
      options: state.options
    });
  };
}
function getInActiveSelections(choices, options) {
  return (0, _filter["default"])(choices, function (c) {
    return (0, _filterInActiveSelections["default"])(c, options, choices);
  }).map(function (item) {
    var option = options[item.optionId];
    return {
      optionId: option.id,
      choiceId: item.id,
      choiceValue: item.value,
      optionTags: option.tags,
      price: item.price
    };
  });
}
function getSelections(choices, options) {
  return (0, _filter["default"])(choices, function (c) {
    return (0, _filterSelections["default"])(c, options, choices);
  }).map(function (item) {
    var option = options[item.optionId];
    return {
      optionId: option.id,
      choiceId: item.id,
      choiceValue: item.value,
      optionTags: option.tags,
      price: item.price
    };
  });
}
function executeRulesApi(immediateRulesOnly) {
  return function (dispatch, getState) {
    var _getSettings = (0, _settings.getSettings)(),
      siteId = _getSettings.siteId,
      zipcode = _getSettings.zipcode,
      onRulesExecuted = _getSettings.onRulesExecuted;
    var _getState$configurato = getState().configurator,
      choices = _getState$configurato.choices,
      options = _getState$configurato.options,
      productInfo = _getState$configurato.productInfo,
      ajaxStatus = _getState$configurato.ajaxStatus;
    var current = getSelections(choices, options);
    // TODO: Remove this. This isn't part of the standard `executerulesviapost`
    // API and shouldn't be forced upon every host application.
    var inactive = getInActiveSelections(choices, options);
    var payload = {
      SiteId: siteId,
      ProductId: productInfo.productId,
      CurrentSelections: current,
      InActiveSelections: inactive
    };
    if (zipcode) {
      payload.ZipCode = zipcode.zipcode;
    }
    dispatch((0, _ajaxStatusActions.beginAjaxCall)());
    return (0, _rulesApi["default"])(payload, immediateRulesOnly).then(function (validation) {
      var rulesData = validation.data;
      dispatch(executeRulesSuccess(rulesData, ajaxStatus.saveAttempts));

      // dispatch updated disabledChoices (so this can potentially be run again)
      dispatch((0, _choiceActions.updateDisabledChoices)(rulesData.disabledChoices));
      dispatch((0, _choiceActions.updateEstimatedArrivalTime)());

      // if onRulesExecuted was setup then call it
      onRulesExecuted && onRulesExecuted();
      return validation;
    })["catch"](function (err) {
      dispatch({
        type: _actionTypes.EXECUTE_RULES_ERROR,
        err: err
      });
    });
  };
}
var executeRules = exports.executeRules = function executeRules() {
  return executeRulesApi(false);
};
var executeImmediateRules = exports.executeImmediateRules = function executeImmediateRules() {
  return executeRulesApi(true);
};
//# sourceMappingURL=rulesActions.js.map